<ng-container>
  <div class="re-relative">
    <label [for]="id || inputName" class="animated fadeInUp re-block re-mr-20"
      [class.re-hidden]="(showValidationErrors && formControl.invalid)"
      [class.hidden]="(inputIsEmpty() && !focused)">
      {{ labelText }}
    </label>

    @if (formControl?.invalid && showValidationErrors) {
      @for (error of formControl?.errors | keyvalue; track error; let i = $index) {
        <!-- show only the first error -->
        @if (i < 1) {
          <div class="error re-mr-20">
            {{error.value}}
          </div>
        }
      }
    }
  </div>


  <div class="re-relative">
    <input
      [id]="id || inputName"
      [name]="inputName"
      [attr.data-qa]="dataQa"
      [formControl]="$any(control)"
      [type]="inputType"
      [placeholder]="placeholder"
      (blur)="onBlur()"
      (select)="onSelect()"
      (focus)="onFocus()"
      (keydown)="onKeyDown()"
      [mask]="maskString"
      [dropSpecialCharacters]="mask === 'date' ? false : true"
      [showMaskTyped]="mask === 'date' ? true : false"
      [autocomplete]="inputType === INPUT_TYPE.PASSWORD || !enableAutocomplete ?
        (autocomplete !== 'off' ? autocomplete : 'new-password') : 'off'"> <!-- Prevent Chrome Autofill-->

      @if (showValidationIcon && !validationIconHidden && !formControl?.disabled && (!formControl?.pending)) {
        <div class="validation-icon">
          <bdo-svg [name]="formControl?.valid ? (isWarning ? 'icon-questionmark' : 'icon-success') : 'icon-alert'"
          [styling]="formControl?.valid ? (isWarning ? 'bdo-svg--alert' : 'bdo-svg--success') : 'bdo-svg--error'"></bdo-svg>
        </div>
      }
      <div class="validation-icon">
        @if (formControl?.pending) {
          <bdo-loading [validation]=true></bdo-loading>
        }
      </div>
    </div>

    @if (help) {
      <div class="bdo-form__helptext" [innerHTML]="help"></div>
    }

    <!-- Tooltip - show if tooltipContent or tooltipTemplate is set -->
    @if (tooltipContent || tooltipTemplate) {
      <div>
        <div class="re-absolute re-right-0 re-top-2">
          <bdo-inline-tooltip>
            @if (tooltipTemplate) {
              <ng-container *ngTemplateOutlet="tooltipTemplate"></ng-container>
            } @else {
              <div [innerHTML]="tooltipContent"></div>
            }
          </bdo-inline-tooltip>
        </div>
      </div>
    }

  </ng-container>
